import { queryOptions } from '@tanstack/react-query'

import { brandsApi } from './brandsApi'

export const brandsQueries = {
  all: () => ['brands'] as const,
  aliasLists: () => [...brandsQueries.all(), 'aliases'] as const,
  aliases: (brandId: string) =>
    queryOptions({
      queryKey: [...brandsQueries.aliasLists(), brandId],
      queryFn: ({ signal }) => brandsApi.getAliases(brandId, { signal }),
    }),
}
